import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { confirmEmail } from '../../api/userApi';
import './ConfirmEmail.css';
import HomeButton from '../common/HomeButton';
import LoadingOverlay from '../common/LoadingOverlay';

const ConfirmEmail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading'); // Possible states: 'loading', 'success', 'noToken', 'sendConfirmFail
    const { t } = useTranslation();

    useEffect(() => {
        const confirm = async () => {
            const token = searchParams.get('token');
            if (!token) {
                setStatus('noToken');
                return;
            }
    
            // Call API to confirm email
            try {
                await confirmEmail(token);
                setStatus('success');
                }
            catch (error) {
                if (error.response && error.response.status === 400) {
                    setStatus('sendConfirmFail');
                } else {
                    console.error('Email confirmation error:', error);
                    setStatus('sendConfirmFail');
                }
            }    
        };

        confirm();
    }, [searchParams]);

    const handleRedirect = () => {
        navigate('/login');
    };

    return (
        <div className="confirm-email-container">
            <HomeButton />
            {status === 'loading' && <LoadingOverlay message={t('confirmEmail.loading')} />}
            {status === 'success' && (
                <div className="success-message">
                    <p>{t('confirmEmail.success')}</p>
                    <button className="big-button action-button" onClick={handleRedirect}>
                        {t('confirmEmail.login')}
                    </button>
                </div>
            )}
            {status === 'noToken' && (
                <div className="error-message">
                    <p>{t('confirmEmail.noToken')}</p>
                    <button className="big-button action-button" onClick={handleRedirect}>
                        {t('confirmEmail.login')}
                    </button>
                </div>
            )}
            {status === 'sendConfirmFail' && (
                <div className="error-message">
                    <p>{t('confirmEmail.fail')}</p>
                    <button className="big-button action-button" onClick={handleRedirect}>
                        {t('confirmEmail.login')}
                    </button>
                </div>
            )}
        </div>
    );
};

export default ConfirmEmail;
